import React from 'react';
import { X, MessageSquare, Map, CheckSquare } from 'lucide-react';
import { Button } from './ui/button';

const DestinationOptionsModal = ({ destination, onClose, onOptionSelect }) => {
  const options = [
    {
      id: 'inquiry',
      title: 'Send Direct Inquiry',
      description: 'Contact us directly to discuss your travel plans and get a customized quote',
      icon: MessageSquare,
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      id: 'trip-builder',
      title: 'Create Your Trip Together',
      description: 'Choose from pre-built itineraries or start from scratch to build your perfect trip',
      icon: Map,
      color: 'bg-amber-500 hover:bg-amber-600'
    },
    {
      id: 'activities',
      title: 'Select Activities & Send Request',
      description: 'Pick your favorite activities and send us your selection for a custom package',
      icon: CheckSquare,
      color: 'bg-green-500 hover:bg-green-600'
    }
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto animate-in fade-in zoom-in duration-300">
        {/* Header with destination image */}
        <div className="relative h-48 overflow-hidden rounded-t-2xl">
          <img 
            src={destination.image} 
            alt={destination.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors"
            data-testid="close-options-modal"
          >
            <X className="w-5 h-5 text-white" />
          </button>
          <div className="absolute bottom-4 left-6">
            <h2 className="text-2xl md:text-3xl font-bold text-white">{destination.name}</h2>
            <p className="text-white/80 text-sm mt-1">{destination.duration} • {destination.type}</p>
          </div>
        </div>

        {/* Options */}
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">How would you like to proceed?</h3>
          
          <div className="space-y-4">
            {options.map((option) => {
              const IconComponent = option.icon;
              return (
                <button
                  key={option.id}
                  onClick={() => onOptionSelect(option.id)}
                  data-testid={`option-${option.id}`}
                  className="w-full flex items-start gap-4 p-4 rounded-xl border-2 border-gray-100 hover:border-amber-200 hover:bg-amber-50/50 transition-all group text-left"
                >
                  <div className={`p-3 rounded-lg ${option.color} text-white shrink-0`}>
                    <IconComponent className="w-6 h-6" />
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-gray-900 group-hover:text-amber-700 transition-colors">
                      {option.title}
                    </h4>
                    <p className="text-sm text-gray-600 mt-1">
                      {option.description}
                    </p>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DestinationOptionsModal;
